




































import Vue from 'vue'
import FilterDropdown from '@/pages/common/filter-dropdown/FilterDropdown.vue'
import Icon from '@/ui/icon/Icon.vue'
import {
  deleteTheme,
  $themes,
  $selectedThemes,
  setSelectedThemes,
  themeDropdownModule,
  componentMounted,
  componentDestroyed,
} from '@/pages/dictionary/themes/create/parts/themes/themes.model'
import { DropdownItem } from '@/pages/common/types'

export default Vue.extend({
  components: {
    FilterDropdown,
    Icon,
  },
  effector: {
    $themes,
    ...themeDropdownModule.store,
    $selectedThemes,
  },
  data() {
    return {
      themeModuleMethods: themeDropdownModule.methods,
    }
  },
  methods: {
    deleteTheme,
    onItemChanged(item: DropdownItem) {
      const existedItem = this.$selectedThemes.find(
        (theme: DropdownItem) => theme.name === item.name
      )
      if (existedItem) {
        const themes = this.$selectedThemes.filter(
          (theme: DropdownItem) => theme.name !== item.name
        )
        setSelectedThemes(themes)
      } else {
        setSelectedThemes([item, ...this.$selectedThemes])
      }
    },
  },
  mounted() {
    componentMounted()
  },
  beforeDestroy() {
    componentDestroyed()
  },
})
